<!--
 * @Author: your name
 * @Date: 2020-06-23 19:19:02
 * @LastEditTime: 2020-08-14 16:09:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\monitoringList\surveillance.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="monitoringListBox">
            <van-nav-bar
                title="视频监控"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <div class="videoListBoxChild">
                    <!-- <iframe
                        :src="videoLink"
                        width="100%"
                        height="100%"
                        frameborder="0"
                    ></iframe> -->
                    <!-- <video style="width:100%;height:auto" autoplay="autoplay">
                        <source
                            src="http://60.211.219.206:9001/102"
                            type="video/ogg"
                            loop="loop"
                            muted
                            autoplay="autoplay"
                            controls="controls"
                        >
                    </video> -->
                    <!-- <video
                        id="vid"
                        loop="loop"
                        src="http://60.211.219.206:9001/102"
                        autoplay="autoplay"
                    ></video> -->
                    <video-player
                        class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions"
                    ></video-player>
                </div>
            </section>
        </div>
    </v-touch>
</template>

<script>
import Vue from 'vue';
import VideoPlayer from 'vue-video-player';
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');

Vue.use(VideoPlayer);

export default {
    data() {
        return {
            // tenantId: '',
            stationId: '',
            // videoLink: '',
            // videoId: '',
            // src: '',
            playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
                autoplay: false, // 如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    type: 'video/mp4',
                    src: '', // url地址          
                }],
                poster: '', // 你的封面地址
                width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true, // 全屏按钮
                },
            },
        };
    },
    created() {
        this.videoId = this.$route.query.id;
        if (this.videoId !== '') {
            this.playerOptions.sources[0].src = `http://60.211.219.206:9001/${this.videoId}`;
        }
        // this.src = encodeURI('http://60.211.219.206:9001/102');
    },
    mounted() {
        // this.tenantId = this.$takeTokenParameters('TenantId');
        // this.stationId = this.$route.query.stationId;
        // this.videoLink = this.$route.query.videoLink;
        // this.videoId = this.$route.query.id;
        // this.playVideo();
    },
    methods: {
        // 返回上一页
        onClickLeft() {
            // this.stopVideo();
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            // this.stopVideo();
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // // 视频播放
        // stopVideo() {
        //     this.$axios
        //         .get(`/interfaceApi/tenant/tenant3dvideo/play/stop/${this.tenantId}/${this.stationId}/${this.videoId}/-`)
        //         .then(() => {
        //             // console.log('播放成功');
        //         })
        //         .catch(error => {
        //             this.$dialog({ message: error.ErrorCode.Message });
        //         });
        // },
        // // 视频播放
        // playVideo() {
        //     this.$axios
        //         .get(`/interfaceApi/tenant/tenant3dvideo/play/${this.tenantId}/${this.stationId}/${this.videoId}/-`)
        //         .then(() => {
        //             // console.log('播放成功');
        //         })
        //         .catch(error => {
        //             this.$dialog({ message: error.ErrorCode.Message });
        //         });
        // },

    },
};

</script>
<style lang='stylus'>
.videoListBoxChild
    height calc(100% - 45rpx)
    -webkit-overflow-scrolling: touch;
    position replace
    iframe
        position absolute
        top 0
        left 0
        right 0
        bottom 0

</style>